import gql from 'graphql-tag'

const internalStockChangesGetQuery = gql`
  query internalStockChangesGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: boolean) {
    internalStockChangesGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "InternalStockChangesResult", method: "POST", path: "internal-stock-change/list") {
      results
      paging
    }
  }
`

export default internalStockChangesGetQuery
